export default {
  values: {
    xs: 0,
    xsSmall: 350,
    xsMedium: 410,
    sm: 600,
    md: 900,
    mdx: 970,
    mds: 1000,
    slg: 1100,
    lg: 1200,
    xlg: 1325,
    xl: 1536,
    uxl: 2000,
  },
};
